export function backOrHome(company_id = 1) {
  if (window.history.length === 1) {
    window.location = `/#/?company_id=${company_id}`
  } else {
    window.history.back()
  }
}
